import React from 'react';
import PropTypes from 'prop-types';

function cancelScrollEvent(event) {
  event.stopImmediatePropagation();
  if (event.cancelable !== false) {
    event.preventDefault();
  }
  // eslint-disable-next-line no-param-reassign
  event.returnValue = false;

  return false;
}

class PreventOutsideScroll extends React.PureComponent {
  static propTypes = {
    children: PropTypes.element.isRequired,
  };

  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      clientY: undefined,
    };

    const { children } = this.props;

    this.childRefName = children.ref ? children.ref : 'child';
  }

  componentDidMount() {
    const child = this.getChild();
    child.addEventListener('wheel', this.onScroll);
    child.addEventListener('touchstart', this.onTouchStart);
    child.addEventListener('touchmove', this.onTouchMove);
  }

  componentWillUnmount() {
    const child = this.getChild();
    child.removeEventListener('wheel', this.onScroll);
    child.addEventListener('touchstart', this.onTouchStart);
    child.addEventListener('touchmove', this.onTouchMove);
  }

  getChild() {
    // eslint-disable-next-line react/no-string-refs
    return this.refs[this.childRefName];
  }

  process(event, yDelta) {
    const child = this.getChild();
    const { scrollTop, scrollHeight, clientHeight: height } = child;

    if (yDelta > 0 && yDelta + height + scrollTop > scrollHeight) {
      child.scrollTop = scrollHeight - height;

      return cancelScrollEvent(event);
    }

    if (yDelta < 0 && scrollTop + yDelta < 0) {
      child.scrollTop = 0;

      return cancelScrollEvent(event);
    }

    return true;
  }

  onScroll = (event) => {
    const wheelDelta = event.deltaY;

    return this.process(event, wheelDelta);
  };

  onTouchStart = (event) => {
    this.setState({
      clientY: event.touches[0].clientY,
    });
  };

  onTouchMove = (event) => {
    const { clientY } = this.state;
    const touchMoveDelta = clientY - event.changedTouches[0].clientY;

    return this.process(event, touchMoveDelta);
  };

  render() {
    const { children } = this.props;

    // не ест массив с одним элементом :(
    return React.cloneElement(children.length === 1 ? children[0] : children, {
      ref: this.childRefName,
    });
  }
}

export default PreventOutsideScroll;
